import React from "react";

export default function WizardConfirmation({
	className,
	title,
	message,
	ctaUrl,
	ctaLabel,
}) {
	return (
		<section className={className}>
			<h2>{title}</h2>
			<p>{message}</p>
			{ctaUrl && ctaLabel && (
				<a className="wizard-confirmation-cta btn" href={ctaUrl}>
					{ctaLabel}
				</a>
			)}
		</section>
	);
}
